import './App.scss';
import { RouterProvider } from 'react-router-dom';
import router from './App.routes.tsx';
import SnackbarComponent from '@components/app-snackbar/app-snackbar.tsx';
import { useFocusSanitizer } from '@hooks/use-focus-sanitizer.ts';
import React from 'react';
import { ErrorBoundary } from '@components/error-boundary';

function App() {
  useFocusSanitizer();

  return (
    <>
      <ErrorBoundary>
        <RouterProvider router={router} />
        <SnackbarComponent />
      </ErrorBoundary>
    </>
  );
}

export default App;
